module.exports = "/_next/static/images/stats-duotone-058b2c66e27051938bc22ea97abac4ab.svg";